import Image from "next/image";
import { Fragment } from "react";
import { getImageDimensions } from "~lib/storyblok";
import type { HeroSectionProps } from "../types";

function HeroBackgroundImage({ blok }: HeroSectionProps) {
  const showHeroOffset =
    typeof blok.heroHeader === "boolean" ? blok.heroHeader : true;
  return (
    <Fragment>
      {blok.backgroundImageDesktop?.filename && (
        <>
          {showHeroOffset && <div className="h-3xl" />}
          <Image
            sizes="100vw"
            src={blok.backgroundImageDesktop.filename}
            alt={blok.backgroundImageDesktop.alt}
            {...getImageDimensions(blok.backgroundImageDesktop)}
            className="section-item-full absolute z-0 h-full object-cover"
            priority
          />
        </>
      )}

      {blok.backgroundImageMobile?.filename && (
        <Image
          sizes="100vw"
          src={blok.backgroundImageMobile.filename}
          alt={blok.backgroundImageMobile.alt}
          {...getImageDimensions(blok.backgroundImageMobile)}
          className="section-item-full absolute z-[1] h-full object-cover sm:hidden"
          priority
        />
      )}
    </Fragment>
  );
}

export { HeroBackgroundImage };
